// [qr-session] Dynamic QR session API service — POS desktop
import { createApiConfig } from '../utils/apiUtils'
import { http } from '../utils/http'

const MOBILE = (slug, path) => `/mobile/${slug}${path}`

// [qr-session] Normalize API snake_case → camelCase
const mapSession = (data) => ({
  qrToken: data.qr_token,
  qrUrl: data.qr_url,
  expiresAt: data.expires_at ? new Date(data.expires_at) : null,
  branchTableId: data.branch_table_id,
  openedAt: data.opened_at ? new Date(data.opened_at) : null,
})

// [qr-session] Create dynamic QR session
export const createQrSession = async (businessSlug, tableId, expiresInMinutes) => {
  const body = {}
  if (expiresInMinutes) body.expires_in_minutes = expiresInMinutes
  const config = createApiConfig({
    method: 'post',
    endpoint: MOBILE(businessSlug, `/branch-table/${tableId}/qr-session`),
    data: body,
  })
  const res = await http(config)
  const data = res.data?.data ?? res.data
  return mapSession(data)
}

// [qr-session] Revoke active QR session
export const revokeQrSession = async (businessSlug, tableId) => {
  const config = createApiConfig({
    method: 'delete',
    endpoint: MOBILE(businessSlug, `/branch-table/${tableId}/qr-session`),
  })
  await http(config)
}

// [qr-session] Regenerate QR session
export const regenerateQrSession = async (businessSlug, tableId, expiresInMinutes) => {
  const body = {}
  if (expiresInMinutes) body.expires_in_minutes = expiresInMinutes
  const config = createApiConfig({
    method: 'post',
    endpoint: MOBILE(businessSlug, `/branch-table/${tableId}/qr-session/regenerate`),
    data: body,
  })
  const res = await http(config)
  const data = res.data?.data ?? res.data
  return mapSession(data)
}
// =====================[QrSessionService]=====================
